import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetAllPembayaranVA = createAsyncThunk(
  "pembayaranVA/GetAllPembayaranVA",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}va/all${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllPembayaranVAUser = createAsyncThunk(
  "pembayaranVA/GetAllPembayaranVAUser",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}va/user${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSinglePembayaranVA = createAsyncThunk(
  "pembayaranVA/GetSinglePembayaranVA",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}va/get_by_id/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreatePembayaranVA = createAsyncThunk(
  "pembayaranVA/CreatePembayaranVA",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}va`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditPembayaranVA = createAsyncThunk(
  "pembayaranVA/EditPembayaranVA",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}va/${data.id}`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeletePembayaranVA = createAsyncThunk(
  "pembayaranVA/DeletePembayaranVA",
  async (data, thunkAPI) => {
    try {
      const response = await axios.delete(`${api}va/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const pembayaranVASlice = createSlice({
  name: "pembayaranVA",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all pembayaran VA
    builder.addCase(GetAllPembayaranVA.pending, loadingHandler);
    builder.addCase(GetAllPembayaranVA.fulfilled, fulfilledHandler);
    builder.addCase(GetAllPembayaranVA.rejected, rejectedHandler);
    // get all pembayaran VA by User ID
    builder.addCase(GetAllPembayaranVAUser.pending, loadingHandler);
    builder.addCase(GetAllPembayaranVAUser.fulfilled, fulfilledHandler);
    builder.addCase(GetAllPembayaranVAUser.rejected, rejectedHandler);
    // get Single pembayaran VA
    builder.addCase(GetSinglePembayaranVA.pending, loadingHandler);
    builder.addCase(GetSinglePembayaranVA.fulfilled, fulfilledHandler);
    builder.addCase(GetSinglePembayaranVA.rejected, rejectedHandler);
    // create pembayaran VA
    builder.addCase(CreatePembayaranVA.pending, loadingHandler);
    builder.addCase(CreatePembayaranVA.fulfilled, fulfilledHandler);
    builder.addCase(CreatePembayaranVA.rejected, rejectedHandler);
    // edit pembayaran VA
    builder.addCase(EditPembayaranVA.pending, loadingHandler);
    builder.addCase(EditPembayaranVA.fulfilled, fulfilledHandler);
    builder.addCase(EditPembayaranVA.rejected, rejectedHandler);
    // delete pembayaran VA
    builder.addCase(DeletePembayaranVA.pending, loadingHandler);
    builder.addCase(DeletePembayaranVA.fulfilled, fulfilledHandler);
    builder.addCase(DeletePembayaranVA.rejected, rejectedHandler);
  },
});

export const { reset } = pembayaranVASlice.actions;
export default pembayaranVASlice.reducer;
